<template>
<div>
    <modal name="rgpd-modal">
        <div class="p-5">
            <h1 class="text-xl font-bold mb-2">{{$t('user.user.login.actors-casino.rgpd.conditions_d_utilisation')}}</h1>
            <hr class="my-3">
            <div v-html="$t('user.user.login.actors-casino.rgpd.rules')"></div>
        </div>
    </modal>

    <sav-template :title="'Inscription'">
        <div v-if="$route.query.next" class="bg-orange-100 border border-orange-200 p-3 my-rounded mb-3 font-light">
            <i class="fa-solid fa-triangle-exclamation mr-1"></i> {{$t('inscription.vous_devez_etre_authentifie_pour_continuer_la_procedure')}}
        </div>
        <div class="mt-3 bg-white p-6 my-rounded shadow">
            <div class="hide-on-mobile">
                <h2 class="text-xl font-bold">{{$t('inscription.creer_un_nouveau_compte')}}</h2>
                <span class="font-light text-sm">{{$t('inscription.inscrivez_vous')}}</span>
                <hr class="my-3">
            </div>
            <template v-for="(item, index) in form">
                <div :key="index">
                    <sav-input class="mb-3" :label="item.label" :type="item.type" :errors="item.errors" v-model="item.value" />
                </div>
            </template>
            <!-- Password -->
            <div class="mb-3">
                <sav-input-password v-model="password" />
            </div>
            <div class="text-right flex justify-between mt-5">
                <span class="text-sm font-light">En créant votre compte, vous acceptez <button class="ml-0 text-gray-800 underline" @click="$modal.show('rgpd-modal')">les conditions d'utilisation</button></span>
                <button :disabled="loading" @click="submit" class="bg-sky-500 hover:bg-sky-600 text-white duration-100 px-3 py-2 text-sm font-light rounded-xl">
                    <template v-if="loading">
                        <sav-spinner />
                    </template>
                    <template v-else> S'inscrire </template>
                </button>
            </div>
        </div>
        <div class="mt-3 text-secondary">
            <small class="mt-3 d-block"> {{$t('inscription.vous_avez_deja_un_compte_?')}}
                <router-link :to="{ name: 'user.login', query: {next: this.redirect} }">
                    <b>
                        <u>{{$t('inscription.connectez_vous')}}</u>
                    </b>
                </router-link>
            </small>
        </div>
    </sav-template>
</div>
</template>

<script>
import sha256 from 'js-sha256';
import apiService from '@/services/api.service';
import SavInputPassword from '@/components/SavInputPassword'
export default {
    components: {SavInputPassword},

    data() {
        return {
            loading: false,
            password: null,
            form: [
                {
                    label: this.$t('inscription.nom'),
                    key: 'lastName',
                    type: 'text',
                    errors: [],
                    value: '',
                    required: true
                },
                {
                    label: this.$t('inscription.prenom'),
                    key: 'firstName',
                    type: 'text',
                    errors: [],
                    value: '',
                    required: true
                },
                {
                    label: this.$t('inscription.email'),
                    key: 'email',
                    type: 'email',
                    errors: [],
                    value: '',
                    required: true
                },
                {
                    label: this.$t('user.user.login.actors-casino.telephone'),
                    key: 'tel',
                    type: 'tel',
                    errors: [],
                    value: '',
                    required: true
                },
            ],
            redirect: ''
        }
    },

    mounted() {
        let client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
        this.redirect = this.$route.query.next

        if (client_id) {
            this.$router.push({name: this.redirect || 'home'})
        }
    },

    methods: {
        validations: function() {
            let hasError = false;

            const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            this.form.forEach(item => {
                item.errors = []
                if (item.required && !item.value) {
                    item.errors.push(this.$t('inscription.champ_incomplet'))
                    hasError = true
                }
                if (item.type === 'email') {
                    if (!regexEmail.test(item.value)) {
                        item.errors.push(this.$t('inscription.veuillez_entrer_un_email_valide'))
                        hasError = true
                    }
                }
            })

            if (!this.password || (this.password && !this.password.valid)) {
                hasError = true
            }
            return !hasError
        },
        getValueByKey(keyname) {
            return this.form.find(item => item.key === keyname).value
        },
        submit: function() {
            if (this.validations()) {
                apiService.post('setlogin', {
                    nom: this.getValueByKey('lastName'),
                    prenom: this.getValueByKey('firstName'),
                    mail: this.getValueByKey('email'),
                    tel: this.getValueByKey('tel'),
                    password: sha256(this.password.password)
                }).then((response) => {
                    if (response.data.posts.post) {
                        localStorage.setItem('client_id', JSON.stringify(response.data.posts.post))

                        if (!this.redirect) {
                            this.$router.push({name: 'home'})
                        } else {
                            this.$router.push({name: this.redirect})
                        }
                    }
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/user/Register.vue